'use strict';

var _extends = require('../../../node_modules/@babel/runtime/helpers/extends.js');
var classCallCheck = require('../../../node_modules/@babel/runtime/helpers/classCallCheck.js');
var createClass = require('../../../node_modules/@babel/runtime/helpers/createClass.js');
var possibleConstructorReturn = require('../../../node_modules/@babel/runtime/helpers/possibleConstructorReturn.js');
var getPrototypeOf = require('../../../node_modules/@babel/runtime/helpers/getPrototypeOf.js');
var inherits = require('../../../node_modules/@babel/runtime/helpers/inherits.js');
var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SplitPaneStickyRight = require('./SplitPaneStickyRight.js');
var withStyles = require('../../../node_modules/@material-ui/core/esm/styles/withStyles.js');
var Grid = require('../../../node_modules/@material-ui/core/esm/Grid/Grid.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _dec, _class;

var styles = function styles(theme) {
  var _container;

  return {
    background: {
      background: theme.palette.background.main,
      minHeight: 'calc(100vh - 120px)'
    },
    container: (_container = {
      minHeight: 'calc(100vh - 120px)'
    }, defineProperty(_container, theme.breakpoints.up('md'), {
      paddingTop: 60
    }), defineProperty(_container, "maxWidth", theme.spacer.centerContentMaxWidth), _container),
    footer: {
      zIndex: 1
    }
  };
};

var StickyParent = (_dec = withStyles(styles), _dec(_class =
/*#__PURE__*/
function (_PureComponent) {
  inherits(StickyParent, _PureComponent);

  function StickyParent() {
    classCallCheck(this, StickyParent);

    return possibleConstructorReturn(this, getPrototypeOf(StickyParent).apply(this, arguments));
  }

  createClass(StickyParent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          leftContent = _this$props.leftContent,
          rightContent = _this$props.rightContent,
          StickyPaneRightProps = _this$props.StickyPaneRightProps;
      return React__default["default"].createElement("div", {
        className: classes.background
      }, React__default["default"].createElement(Grid["default"], {
        container: true,
        justify: "center"
      }, React__default["default"].createElement(Grid["default"], {
        item: true,
        xs: 12,
        className: classes.container
      }, React__default["default"].createElement(SplitPaneStickyRight["default"], _extends["default"]({
        leftPane: leftContent,
        rightPane: rightContent
      }, StickyPaneRightProps)))));
    }
  }]);

  return StickyParent;
}(React.PureComponent)) || _class);

module.exports = StickyParent;
